import { Navigate, useParams } from 'react-router';

/** Vendas moved into Analytics › Pedidos; old links and bookmarks land there (SALES-08 AC 4). */
export function SalesRedirect() {
  const { tenantSlug } = useParams();
  return <Navigate replace to={`/${tenantSlug}/metrics?tab=orders`} />;
}
